import httpClient from '@/http-client'

export const get = (Options = {}) => {
	return httpClient
		.get('/api/v1/reports/additional-infos', Options)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}

export const additionalInfoExcel = data => {
	return httpClient
		.post('/api/v1/reports/additional-infos/excels', data, {
			responseType: 'arraybuffer'
		})
		.then(response => Promise.resolve(response))
		.catch(error => Promise.reject(error.response.data))
}

export default { get, additionalInfoExcel }
